/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoFacebookIcon16Light } from './LogoFacebookIcon16Light';
import { LogoFacebookIcon16Regular } from './LogoFacebookIcon16Regular';
import { LogoFacebookIcon16Solid } from './LogoFacebookIcon16Solid';
import { LogoFacebookIcon20Light } from './LogoFacebookIcon20Light';
import { LogoFacebookIcon20Regular } from './LogoFacebookIcon20Regular';
import { LogoFacebookIcon20Solid } from './LogoFacebookIcon20Solid';
import { LogoFacebookIcon24Regular } from './LogoFacebookIcon24Regular';
import { LogoFacebookIcon24Solid } from './LogoFacebookIcon24Solid';
import { LogoFacebookIcon32Regular } from './LogoFacebookIcon32Regular';
import { LogoFacebookIcon64Regular } from './LogoFacebookIcon64Regular';
var sizes = {
    16: {
        light: LogoFacebookIcon16Light,
        regular: LogoFacebookIcon16Regular,
        solid: LogoFacebookIcon16Solid,
    },
    20: {
        light: LogoFacebookIcon20Light,
        regular: LogoFacebookIcon20Regular,
        solid: LogoFacebookIcon20Solid,
    },
    24: {
        regular: LogoFacebookIcon24Regular,
        solid: LogoFacebookIcon24Solid,
    },
    32: {
        regular: LogoFacebookIcon32Regular,
    },
    64: {
        regular: LogoFacebookIcon64Regular,
    },
};
export var LogoFacebookIcon = forwardRef('LogoFacebookIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
